import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { interpolate } from 'helpers/interpolate';
import { Link } from 'react-router';
import { nextMidnight } from 'components/CountdownTimer/CountdownTimer';
import { OfferExpiryCountdown } from './OfferExpiryCountdown';

export class ClassUnavailable extends PureComponent {
  render() {
    const { ctaText, displayName, legal, purchaseUrl, subtitle, title, venueName } = this.props;
    const interpolationConfig = {
      $USER_NAME: displayName,
      $VENUE_NAME: venueName,
    };
    const promoTitle = interpolate(title, interpolationConfig);
    const promoSubtitle = interpolate(subtitle, interpolationConfig);

    return (
      <section className="class-unavailable">
        <h1 className="class-unavailable__title">{promoTitle}</h1>
        {!!promoSubtitle && <p className="class-unavailable__subtitle">{promoSubtitle}</p>}
        <Link to={purchaseUrl} className="class-unavailable__cta bt bt--primary mb-">
          {ctaText}
        </Link>
        {!!legal && <p className="class-unavailable__legal color-text-light text--sm">{legal}</p>}
        <OfferExpiryCountdown countdownTo={nextMidnight()} />
      </section>
    );
  }
}

ClassUnavailable.propTypes = {
  ctaText: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  legal: PropTypes.string,
  purchaseUrl: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  venueName: PropTypes.string,
};
